import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

export default class CollapsableTableRow extends Component {
  state = {
    isCollapsed: true,
  };

  componentDidMount() {
    const { initialIsCollapsed } = this.props;

    this.setState(state => ({
      ...state,
      isCollapsed: initialIsCollapsed,
    }));
  }

  toggleCollapse = () => {
    this.setState(state => ({
      ...state,
      isCollapsed: !state.isCollapsed,
    }));
  };

  render() {
    const { children, isCollapsable, renderDetail, rowProps } = this.props;
    const { isCollapsed } = this.state;

    // Count of all <td> elements + 1 for column for toggle collapse
    const totalColumns = React.Children.toArray(children).length + 1;

    return (
      <tbody className="hover">
        <tr {...rowProps}>
          <td>
            {isCollapsable && (
              <a onClick={() => this.toggleCollapse()}>
                <i
                  className={classNames('fa pointer', {
                    'fa-caret-up': !isCollapsed,
                    'fa-caret-down': isCollapsed,
                  })}
                />
              </a>
            )}
          </td>
          {children}
        </tr>
        {!isCollapsed && isCollapsable && (
          <tr>
            <td />
            <td colSpan={totalColumns - 1}>{renderDetail()} </td>
          </tr>
        )}
      </tbody>
    );
  }

  static propTypes = {
    initialIsCollapsed: PropTypes.bool,
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
    isCollapsable: PropTypes.bool,
    renderDetail: PropTypes.func,
    rowProps: PropTypes.shape({}),
  };

  static defaultProps = {
    initialIsCollapsed: true,
    isCollapsable: true,
    renderDetail: () => {},
    rowProps: {},
  };
}
